import { makeVar } from "@apollo/client";
import { createContext } from "react";

export type ChatSessionLoadingTextType = {
  chatSessionId: number;
  text: string;
} | null;

export type ChatToolCallType = {
  chatSessionId: number;
  callId: string;
  toolName: string;
  resultCount?: number;
  description?: string;
  status?: "started" | "completed" | "failed";
};

export const chatSessionLoadingTextVar =
  makeVar<ChatSessionLoadingTextType | null>(null);

export const chatToolCallsVar = makeVar<ChatToolCallType[]>([]);

// Set to trigger an auto-submitted prompt in AskAI for a given meeting (e.g.
// the "Prepare with Topicflow AI" card on an empty 1-on-1), or for an AskAI
// that opted in with a matching `pendingPromptTarget` (e.g. the Roles and
// Competencies sidebar). AskAI consumes it once and clears the var.
export type PendingChatPromptType = {
  meetingId?: number;
  target?: string;
  prompt: string;
} | null;
export const pendingChatPromptVar = makeVar<PendingChatPromptType>(null);

export const ChatSessionContext = createContext<{
  assessmentId?: number;
  assessmentQuestionId?: number;
  meetingId?: number;
  currentSuggestedAssessmentResponseId?: string | null;
  setCurrentSuggestedAssessmentResponseId?: (id: string | null) => void;
}>({
  assessmentId: undefined,
  assessmentQuestionId: undefined,
  meetingId: undefined,
  currentSuggestedAssessmentResponseId: null,
  setCurrentSuggestedAssessmentResponseId: undefined,
});
